import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initErrorReporter } from './utils/errorReporter';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from './utils/env';

// Runtime error log (fleet-testing/shared/errors): crashes and failed backend calls from real
// browsers land in public.client_errors, read with `node shared/errors/triage.js`.
initErrorReporter({
  project: 'tradesmatepro',
  app: 'contractor-app',
  enabled: process.env.NODE_ENV === 'production' && !/^(localhost|127\.0\.0\.1)$/.test(window.location.hostname),
  endpoint: `${SUPABASE_URL}/rest/v1/client_errors`,
  headers: { apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${SUPABASE_ANON_KEY}` },
  watchUrls: [`${SUPABASE_URL}/rest/v1/`, `${SUPABASE_URL}/functions/v1/`],
  // 401 = an expired session mid-refresh, which supabase-js retries on its own.
  ignoreHttp: (status) => status === 401,
  // The legacy embedded portal route carries a quote access token in the path.
  redact: [[/\/portal\/quote\/view\/[^/?#\s]+/, '/portal/quote/view/[token]']],
  getContext: () => {
    const u = JSON.parse(localStorage.getItem('trademate_user') || '{}');
    return { company_id: u.company_id || null, user_id: u.id || null, role: u.db_role || null };
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
